import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import TurnTable from './TurnTable'
import TurnDrawer from './TurnDrawer'
import turnSrc from '../../turnSrc'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import DBService from '../../../../utils/DBService'

function Turns() {
  const [dataSource, setDataSource] = useState([])
  const [loading, setLoading] = useState(false)
  const [editDataDrawer, setEditDataDrawer] = useState(null)
  const [nextPage, setNextPage] = useState('')
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [showTurnDrawer, setShowTurnDrawer] = useState(false)
  const [companyId, setCompanyId] = useState('')
  const [paymentMethods, setPaymentMethods] = useState([])

  useEffect(() => {
    loadTurnInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (editDataDrawer) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editDataDrawer])
  
  async function fetchData() {
    let _paymentMethods = await DBService.getAll('paymentMethods')

    let arrayDataAux = []
    _paymentMethods.forEach(element => {
      if (element.company_id === 0) {
        arrayDataAux.push(element)
      }
    });

    const arrayData = editDataDrawer._store.company.payment_methods.concat(arrayDataAux);
    const arrayDataSorted = arrayData.sort((a, b) => a.id - b.id)

    setPaymentMethods(arrayDataSorted)
  }

  const loadTurnInfo = () => {
    setLoading(true)
    turnSrc
      .read('', 5, true, 'desc')
      .then(response => {        
        if (response.data.data.length > 0) {
          setCompanyId(response.data.data[0].store.id)
        }
        setDataSource(getTurns(response))
        setNextPage(response.data.next_page_url)
        setExistMoreInfo(response.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar la información.')
      })
  }

  const getTurns = turns => {
    if (turns !== 'Too Many Attempts.') {
      let _turns = turns.data.data || []

      return _turns.map((d, i) => ({
        key: i,
        _id: d.id,
        _turn_id: d.turn_id,
        _store: d.store,
        _store_name: validatePositions(d.store, 'name') ? d.store.name : null,
        _turn: d.store.turns[0],
        _open_date: d.open_date,
        _nameUser: validatePositions(d.open_by, 'name') ? d.open_by.name : null,

      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const validatePositions = (data, strPosition, boolObject = false) => {
    if (data !== null && data !== undefined) {
      let boolPosition = false
      if (strPosition !== '' && typeof data[strPosition] !== 'undefined') {
        boolPosition = true
      } else if (boolObject) {
        Object.keys(data).length > 0 ? (boolPosition = true) : (boolPosition = false)
      }
      return boolPosition
    }
    return false
  }

  const searchText = data => {
    setLoading(true)
    turnSrc.read(data, 5).then(response => {
      setDataSource(getTurns(response))
      setNextPage(response.data.next_page_url)
      setExistMoreInfo(response.data.next_page_url !== null)
      setLoading(false)
    })
  }

  const handlerCloseTurn = data => {
    setCompanyId(data._store.company.id)
    setEditDataDrawer(data)
    setShowTurnDrawer(true)
  }

  const handlerMoreButton = () => {
    setExistMoreInfo(false)
    if (existMoreInfo) {
      setLoading(true)
      turnSrc.storeNextPage(nextPage).then(response => {
        setDataSource(dataSource.concat(getTurns(response)))
        setNextPage(response.data.next_page_url)
        setExistMoreInfo(response.data.next_page_url !== null)
        setLoading(false)
      })
    }
  }

  return (
    <>
      <TurnDrawer
        closable={() => setShowTurnDrawer(false)}
        visible={showTurnDrawer}
        info={editDataDrawer}
        loadTurnInfo={loadTurnInfo}
        companyId={companyId}
        paymentMethods={paymentMethods}
      />
      <TurnTable isLoading={loading} dataSource={dataSource} handlerTextSearch={searchText} handlerCloseTurn={handlerCloseTurn} />
      <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
    </>
  )
}

export default Turns
